<template>
  <div
    class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
  >
    <div class="flex flex-row items-end">
      <div
        class="bg-theme-9 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
      >
        RF
      </div>
      <h2 class="text-lg font-medium ml-4">
        {{ formRF.rfEdit ? 'แก้ไข RF ' + formRF.docNoFull : 'สร้าง RF' }}
      </h2>
      <OverBudget />
    </div>
    <div
      class="flex flex-row justify-end mt-4 lg:mt-0 gap-2"
      v-if="!loadingPage"
    >
      <router-link
        type="button"
        :to="{ name: 'preorderRFList' }"
        class="btn box text-gray-700 flex items-center"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        data-toggle="modal"
        data-target="#cancel-modal-preview"
        :disabled="btnCancel.disabled"
        v-show="!btnCancel.hide"
      >
        <XCircleIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnCancel.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ยกเลิกเอกสาร
      </a>
      <button
        type="button"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        @click.prevent="rejectRF()"
        :disabled="btnReject.disabled"
        v-show="!btnReject.hide"
      >
        <ArrowLeftIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnReject.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ดึงเอกสารกลับ
      </button>
      <button
        type="button"
        class="btn box text-gray-700 disabled:opacity-50 flex items-center"
        @click.prevent="saveRF(true)"
        :disabled="btnDraft.disabled"
        v-show="!btnDraft.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnDraft.loading"
        />
        <LoadingIcon icon="oval" color="blue" v-else class="w-4 h-4 mr-2" />
        บันทึกแบบร่าง
      </button>
      <button
        type="button"
        class="btn btn-primary disabled:opacity-50 flex items-center"
        @click.prevent="saveRF(false)"
        :disabled="btnSave.disabled"
        v-show="!btnSave.hide"
      >
        <FileTextIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnSave.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        บันทึก และส่งอนุมัติ
      </button>
    </div>
  </div>
  <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="mb-5" v-if="formRF.isEdit">
            <DocumentPath
              :document-path="formRF.documentPathArray"
              :status-code="formRF.statusCode"
              :next-status-code="formRF.nextStatus"
              :approve-result="formRF.approveResultArray"
            />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5">
            <!-- logo -->
            <div class="col-span-1 md:mr-4 box flex flex-col justify-center">
              <div
                class="w-full h-auto flex flex-row justify-center bg-white p-4"
              >
                <img
                  v-if="companyDefault"
                  :src="companyDefault.comp_logo_url"
                  class=""
                  alt=""
                />
              </div>
            </div>
            <div class="col-span-2 lg:col-span-4 mt-4 md:mt-0">
              <!-- ตำแหน่งเอกสาร -->
              <div class="intro-y box p-5">
                <div class="flex flex-col lg:flex-row lg:space-x-4">
                  <div class="text-theme-6">
                    ตำแหน่งเอกสาร : ฝ่ายจัดซื้อดำเนินการ
                  </div>
                  <div class="text-theme-10">
                    ผู้ดำเนินการ : {{ userInfo ? userInfo.fullname : '' }}
                  </div>
                </div>
              </div>
              <!-- สายอนุมัติของผู้เปิดเอกสาร -->
              <div class="intro-y box p-5 mt-5 lg:flex lg:justify-between">
                <div>
                  <div>สายอนุมัติของผู้เปิดเอกสาร :</div>
                  <div class="font-bold">
                    {{
                      documentPathText
                        ? documentPathText.join(' -> ')
                        : 'ไม่ระบุ'
                    }}
                  </div>
                </div>
                <div>
                  <select
                    v-model="specialPathSelected"
                    class="form-control form-select"
                    @change="
                      onChangeDocumentPath({ target: 'select-special-path' })
                    "
                  >
                    <option :value="null"
                      >ตรวจสอบสายอนุมัติของผู้เปิดเอกสารตามวงเงิน</option
                    >
                    <option
                      v-for="spacialPath in documentSpacialPathOptions"
                      :key="spacialPath.name"
                      :value="spacialPath.name"
                      >{{ spacialPath.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="box intro-y mt-5 p-5">
            <div class="text-lg font-bold">
              ข้อมูลผู้สร้างเอกสาร
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-5">
              <!-- ชื่อผู้ขอเบิก -->
              <div>
                <div class="w-full">
                  <label class="form-label">ชื่อผู้ขอเบิก </label>
                  <div class="preview w-full">
                    <WfSelectSingleEmployee
                      :disabled="lockField.status"
                      key="wfselect-employee"
                      v-model="formRF.employeeSelected"
                      :showBtnClear="false"
                      :options="{
                        searchMinLength: 3
                      }"
                      @change="onChangeDocumentPath"
                    ></WfSelectSingleEmployee>
                  </div>
                  <span class="text-theme-6" v-show="lockField.status">{{
                    lockField.label
                  }}</span>
                </div>
              </div>
              <!-- หน่วยงาน / บริษัท -->
              <div>
                <label class="form-label">หน่วยงาน / บริษัท </label>
                <select
                  name=""
                  v-model="formRF.companySelected"
                  @change="onChangeDocumentPath({ target: 'select-company' })"
                  class="form-select w-full"
                  :disabled="lockField.status"
                >
                  <option
                    v-for="company in companyOptions"
                    :key="company.comp_no"
                    :value="company.comp_no"
                    >{{ company.comp_name_th }}</option
                  >
                </select>
                <span class="text-theme-6" v-show="lockField.status">{{
                  lockField.label
                }}</span>
              </div>
              <!-- รหัสหน่วยงาน -->
              <div>
                <label class="form-label">รหัสหน่วยงาน</label>
                <div class="" v-if="employeeDefault">
                  {{ employeeDefault.bu_no }} ({{ employeeDefault.bu_name }})
                </div>
              </div>
              <!-- เบอร์ติดต่อ -->
              <div>
                <label class="form-label"
                  >เบอร์ติดต่อ <span class="text-theme-6">*</span></label
                >
                <div>
                  <input
                    type="text"
                    refs="titleRef"
                    v-model="validateRF.telephone.$model"
                    class="form-control w-full"
                    :class="{
                      'border-theme-6': validateRF.telephone.$error
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-1 mt-5">
            <div class="">
              <!-- รายละเอียดใบสั่งซื้อ/สัญญา -->
              <div class="intro-y box p-5">
                <div class="flex justify-between">
                  <div class="font-bold text-lg">
                    รายละเอียดใบสั่งซื้อ/สัญญา
                  </div>
                  <a
                    class="btn btn-warning"
                    href="javascript:;"
                    data-toggle="modal"
                    data-target="#modal-of-list"
                    @click="openModalOFList"
                    v-if="!formRF.rfEdit"
                  >
                    เลือก OF or Vendor
                  </a>
                </div>
                <div>
                  <!-- เลือก PO -->
                  <!-- <div class="mt-4">
                    <a
                      class="w-full btn btn-warning"
                      href="javascript:;"
                      data-toggle="modal"
                      data-target="#modal-of-list"
                      @click="openModalOFList"
                      v-if="!formRF.rfEdit"
                    >
                      เลือก OF
                      {{ docNoFull !== null ? 'เลขที่ ' + docNoFull : '' }}
                    </a>
                    <div v-else class="font-bold">เลขที่: {{ docNoFull }}</div>
                  </div> -->
                  <div
                    class="grid grid-cols-2 lg:gap-4 mt-4"
                    v-show="isLoadingRFList"
                  >
                    <div class="space-y-2">
                      <!-- ผู้ค้า -->
                      <div class="">
                        <label class="form-label font-bold">ผู้ค้า:</label>
                        <div>
                          {{ formOF.vendorCode }} - {{ formOF.vendorName }}
                        </div>
                      </div>
                      <!-- ที่อยู่ -->
                      <div class="">
                        <label class="form-label font-bold">ที่อยู่:</label>
                        <div>{{ formOF.vendorAddress }}</div>
                      </div>
                      <!-- โทร -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold">โทร:</label>
                        <div>{{ formOF.vendorTelephone }}</div>
                      </div>
                      <!-- อีเมล์ -->
                      <div class="flex justify-between">
                        <label class="form-label font-bold">Email:</label>
                        <div>{{ formOF.vendorEmail }}</div>
                      </div>
                    </div>
                    <div class="space-y-2">
                      <div class="">
                        <label class="form-label font-bold">Payee:</label>
                        <div class="preview w-full">
                          <WfSelectSinglePayee
                            key="wfselect-item-payee"
                            v-model="formRF.payeeSelected"
                            :options="{
                              ajaxLimit: 50,
                              searchMinLength: 3
                            }"
                          ></WfSelectSinglePayee>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-show="isLoadingRFList"
                    v-for="ofHeader of ofChosen"
                    :key="ofHeader.of_id"
                  >
                    <div
                      class="grid grid-cols-1 lg:grid-cols-2 lg:gap-4 mt-4 border rounded-lg p-4"
                    >
                      <div class="space-y-2">
                        <!-- ใบสั่งซื้อ/สัญญา -->
                        <div class="flex justify-between">
                          <label class="form-label font-bold"
                            >ใบสั่งซื้อ/สัญญา:
                          </label>
                          <div>
                            <a
                              :href="viewOF(ofHeader.of_id)"
                              class="text-theme-10 underline underline-offset-2"
                              target="_blank"
                              >{{ ofHeader.doc_no_full }}</a
                            >
                          </div>
                        </div>

                        <!-- สกุลเงิน -->
                        <div class="flex justify-between">
                          <label class="form-label font-bold">สกุลเงิน:</label>
                          <div>{{ ofHeader.currency_code }}</div>
                        </div>
                        <!-- ชนิดของการซื้อ -->
                        <div class="flex justify-between">
                          <label class="form-label font-bold"
                            >ชนิดของการซื้อ:</label
                          >
                          <div>{{ ofHeader.order_type_text }}</div>
                        </div>
                        <!-- ส่วนลดรวม -->
                        <!-- <div class="flex justify-between">
                          <label class="form-label font-bold">ส่วนลดรวม:</label>
                          <div>{{ numberFormat(formOF.discountAllItem) }}</div>
                        </div> -->
                      </div>
                      <div class="space-y-2">
                        <div class="flex justify-between">
                          <label class="form-label font-bold">Memo:</label>
                          <div v-if="ofHeader.ememo_id">
                            <a :href="ofHeader.ememo_link" target="_blank">{{
                              ofHeader.ememo_title
                            }}</a>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </div>
                        <!-- ไฟล์แนบ -->
                        <div class="mt-2">
                          <div class="col-span-1">
                            <label class="form-label font-bold">ไฟล์แนบ:</label>
                            <AttachFilePreview
                              :data="ofHeader.file_attach_array"
                            />
                          </div>
                        </div>
                        <!-- รายละเอียด -->
                        <div class="col-span-2">
                          <label class="form-label font-bold"
                            >รายละเอียด:</label
                          >
                          <div
                            v-html="
                              ofHeader.req_detail
                                ? ofHeader.req_detail.replaceAll('\n', '<br>')
                                : ''
                            "
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- ข้อมูลการจัดส่ง -->
          </div>
          <!-- รายละเอียดการตรวจรับ -->
          <div class="intry-y box p-5 mt-5" v-show="isLoadingRFList">
            <div class="">
              <div class="font-bold text-lg">รายละเอียดการตรวจรับ</div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
              <!-- ใบส่งของ เลขที่ -->
              <div>
                <label class="form-label"
                  >ใบส่งของ เลขที่ <span class="text-theme-6">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="validateRF.invoiceNo.$model"
                  :class="{
                    'border-theme-6': validateRF.invoiceNo.$error
                  }"
                  maxlength="50"
                  placeholder="(ไม่เกิน 50 ตัวอักษร)"
                />
                <span class="text-theme-6" v-if="validateRF.invoiceNo.$error">{{
                  validateRF.invoiceNo.required.$message
                }}</span>
                <span class="text-xs text-gray-500"
                  >* ใบส่งของ/ใบแจ้งหนี้/ใบกำกับภาษี</span
                >
              </div>
              <!-- รับสินค้า ณ วันที่ -->
              <div>
                <label class="form-label"
                  >รับสินค้า ณ วันที่ <span class="text-theme-6">*</span></label
                >
                <div class="p-fluid p-grid">
                  <div class="p-field p-field-sm">
                    <Calendar
                      placeholder="2022-01-01"
                      inputStyle="padding:0.5rem 0.75rem;"
                      v-model="validateRF.reqDate.$model"
                      :inputClass="validateRF.reqDate.$error ? 'p-invalid' : ''"
                      dateFormat="yy-mm-dd"
                    />
                  </div>
                </div>
                <span class="text-theme-6" v-if="validateRF.reqDate.$error">{{
                  validateRF.reqDate.required.$message
                }}</span>
                <span class="text-xs text-gray-500"
                  >* รับสินค้า/รับ Inv. /กรรมการตรวจรับ ณ วันที่</span
                >
              </div>
              <!-- วันที่ใบแจ้งหนี้ -->
              <div>
                <label class="form-label"
                  >วันที่ใบแจ้งหนี้ <span class="text-theme-6">*</span></label
                >
                <div class="p-fluid p-grid">
                  <div class="p-field p-field-sm">
                    <Calendar
                      placeholder="2022-01-01"
                      inputStyle="padding:0.5rem 0.75rem;"
                      v-model="validateRF.invoiceDate.$model"
                      :inputClass="
                        validateRF.invoiceDate.$error ? 'p-invalid' : ''
                      "
                      dateFormat="yy-mm-dd"
                    />
                  </div>
                </div>
                <span
                  class="text-theme-6"
                  v-if="validateRF.invoiceDate.$error"
                  >{{ validateRF.invoiceDate.required.$message }}</span
                >
              </div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
              <!-- GL Date -->
              <div>
                <label class="form-label">GL Date</label>
                <div class="p-fluid p-grid">
                  <div class="p-field p-field-sm">
                    <Calendar
                      placeholder="2022-01-01"
                      inputStyle="padding:0.5rem 0.75rem;"
                      v-model="formRF.glDate"
                      dateFormat="yy-mm-dd"
                    />
                  </div>
                </div>
              </div>
              <div>
                <label class="form-label">สกุลเงิน</label>
                <div class="font-bold w-full">
                  <select
                    name=""
                    v-model="formRF.currencySelected"
                    class="form-select form-control"
                  >
                    <option
                      v-for="(currency, ind) in currencyOptions"
                      :key="ind"
                      :value="currency"
                      >{{ currency }}</option
                    >
                  </select>
                </div>
              </div>
              <div>
                <label class="form-label">ชนิดของการซื้อ</label>
                <div class="font-bold w-full">
                  <select
                    name=""
                    v-model="formRF.orderTypeSelected"
                    class="form-select form-control"
                  >
                    <option
                      v-for="type in orderTypeOptions"
                      :key="type.value"
                      :value="type.value"
                    >
                      {{ type.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-4 mt-5 lg:gap-4">
              <!-- รายละเอียด -->
              <div class="col-span-3">
                <label class="form-label"
                  >รายละเอียด <span class="text-theme-6">*</span></label
                >
                <!-- <textarea
                  rows="7"
                  class="form-control"
                  v-model="validateRF.reqDetail.$model"
                  :class="{
                    'border-theme-6': validateRF.reqDetail.$error
                  }"
                  placeholder="เพิ่มเติม..."
                ></textarea> -->
                <div
                  :class="{
                    'border-theme-6 border': validateRF.reqDetail.$error
                  }"
                >
                  <TextEditor v-model="validateRF.reqDetail.$model" />
                </div>

                <span class="text-theme-6" v-if="validateRF.reqDetail.$error">{{
                  validateRF.reqDetail.required.$message
                }}</span>
              </div>
              <div>
                <!-- ไฟล์แนบ -->
                <div class="mt-4">
                  <label for="" class="form-label">เลือกเอกสารจาก Memo</label>
                  <MemoAutoComplete
                    :options="memoOptions"
                    v-model="formRF.memoSelected"
                    v-model:selectedMemo="selectedMemo"
                  />
                </div>
                <div class="mt-2">
                  <label class="form-label"
                    >ไฟล์แนบ {{ fileUploadMaxSize }} MB</label
                  >
                  <AttachFileUpload module="rf" />
                </div>
              </div>
            </div>
          </div>

          <!-- PR Item -->
          <div class="grid grid-cols-1 mt-5 box intro-y" v-show="boxItemOpen">
            <div class="box p-5">
              <div class="text-lg font-bold mb-4">รายการตรวจรับ</div>
              <div class="border p-5 rounded-lg mb-4">
                <div class="text-lg mb-4">รายละเอียดสินค้า</div>
                <div class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4">
                  <div class="space-y-4">
                    <!-- หมวดหมู่สินค้า -->
                    <div class="">
                      <label for="material-gl-category" class="form-label"
                        >หมวดหมู่สินค้า</label
                      >
                      <input
                        type="text"
                        id="material-gl-category"
                        class="form-control"
                        disabled
                        v-model="formOFItem.materialInfo.material_group"
                      />
                    </div>
                    <!-- รหัสชนิดสินค้า -->
                    <div class="">
                      <label for="material-description-code" class="form-label"
                        >รหัสชนิดสินค้า</label
                      >
                      <input
                        type="text"
                        id="material-description-code"
                        class="form-control"
                        disabled
                        v-model="formOFItem.materialInfo.description_code"
                      />
                    </div>
                    <!-- ส่วนลดจากการต่อรอง -->
                    <!-- <div class="">
                      <label for="barainDiscount" class="form-label"
                        >ส่วนลดจากการต่อรอง</label
                      >
                      <textarea
                        id="barainDiscount"
                        class="form-control"
                        rows="5"
                        v-model="formOFItem.bargainDiscount"
                      ></textarea>
                    </div> -->
                    <!-- <div>
                      <div class="text-lg mb-4">รายละเอียดการตรวจรับ</div>
                      <div
                        class="flex flex-row lg:flex-col justify-between mb-2"
                      >
                        <label class="form-label font-bold"
                          >ยอดรวมที่ทำรับไปแล้ว:</label
                        >
                        <div>{{ remain.sumActualCost }}</div>
                      </div>
                      <div
                        class="flex flex-row lg:flex-col justify-between mb-2"
                      >
                        <label class="form-label font-bold"
                          >งวดที่ทำรับล่าสุด:</label
                        >
                        <div>{{ remain.instalmentLatest }}</div>
                      </div>
                      <div
                        class="flex flex-row lg:flex-col justify-between mb-2"
                      >
                        <label class="form-label font-bold">ยอดคงเหลือ:</label>
                        <div>{{ remain.remainActualCost }}</div>
                      </div>
                    </div> -->
                  </div>
                  <div class="col-span-2">
                    <!-- รายการสินค้า -->
                    <div class="mb-3">
                      <label for="material-description" class="form-label"
                        >รายการสินค้า <span class="text-theme-6">*</span></label
                      >
                      <textarea
                        id="material-description"
                        rows="5"
                        readonly
                        class="form-control"
                        :class="{
                          'border-theme-6':
                            validateItem.materialInfo.description.$error
                        }"
                        v-model="validateItem.materialInfo.description.$model"
                      ></textarea>
                      <span
                        class="text-theme-6"
                        v-if="validateItem.materialInfo.description.$error"
                        >{{
                          validateItem.materialInfo.description.required
                            .$message
                        }}</span
                      >
                    </div>
                    <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-4">
                      <div class="space-y-4">
                        <!-- หน่วยนับ -->
                        <div class="">
                          <label for="material-type" class="form-label"
                            >หน่วยนับ <span class="text-theme-6">*</span></label
                          >
                          <select
                            id="material-type"
                            class="form-select form-control w-full"
                            v-model="validateItem.uomSelected.$model"
                            :class="{
                              'border-theme-6': validateItem.uomSelected.$error
                            }"
                          >
                            <option :value="null" key="0"
                              >-- เลือกหน่วยนับ --</option
                            >
                            <option
                              :value="uom.value"
                              v-for="uom in uomOptions"
                              :key="uom.value"
                              >{{ uom.label }}</option
                            >
                          </select>
                          <span
                            class="text-theme-6"
                            v-if="validateItem.uomSelected.$error"
                            >{{
                              validateItem.uomSelected.required.$message
                            }}</span
                          >
                        </div>
                        <div>
                          <!-- หน่วยนับที่เล็กที่สุด -->
                          <label for="stock-unit-for-pos" class="form-label"
                            >จำนวน หน่วยเล็กสุดตาม POS
                            <span class="font-bold"></span
                            ><span class="text-theme-6">*</span></label
                          >
                          <div class="input-group">
                            <input
                              v-model="formOFItem.qtyPos"
                              type="text"
                              id="stock-unit-for-pos"
                              class="form-control"
                              disabled
                              min="0"
                            />
                            <div class="input-group-text">
                              {{ formOFItem.stockUnitName }}
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-span-1">
                              <button class="btn btn-secondary w-full">
                                หน่วย :
                                {{ formOFItem.stockUnitName }}
                              </button>
                            </div> -->
                        <!-- วันที่ต้องการใช้ -->
                        <div class="">
                          <label for="" class="form-label "
                            >วันที่ต้องการใช้
                            <span class="text-theme-6">*</span></label
                          >
                          <div class="p-fluid p-grid">
                            <div class="p-field p-field-sm">
                              <Calendar
                                placeholder="2022-01-01"
                                inputStyle="padding:0.5rem 0.75rem;"
                                v-model="validateItem.useDate.$model"
                                :inputClass="
                                  validateItem.useDate.$error ? 'p-invalid' : ''
                                "
                                dateFormat="yy-mm-dd"
                              />
                            </div>
                          </div>
                          <span
                            class="text-theme-6"
                            v-if="validateItem.useDate.$error"
                            >{{ validateItem.useDate.required.$message }}</span
                          >
                        </div>
                        <!-- สถานที่รับสินค้า -->
                        <div class="">
                          <label for="material-pickup-loc" class="form-label"
                            >สถานที่รับสินค้า
                            <span class="text-theme-6">*</span></label
                          >
                          <textarea
                            id="material-pickup-loc"
                            rows="5"
                            class="form-control"
                            :class="{
                              'border-theme-6': validateItem.pickupLoc.$error
                            }"
                            v-model="validateItem.pickupLoc.$model"
                          ></textarea>
                          <span
                            class="text-theme-6"
                            v-if="validateItem.pickupLoc.$error"
                            >{{
                              validateItem.pickupLoc.required.$message
                            }}</span
                          >
                        </div>
                      </div>
                      <div class="space-y-4">
                        <!-- เลือกประเภทการใช้ราคา -->
                        <!-- <div class="">
                          <label for="material-price" class="form-label"
                            >เลือกประเภทการใช้ราคา</label
                          >
                          <div class="form-check gap-4">
                            <div>
                              <input
                                type="radio"
                                class="form-check-input"
                                id="use-price-po"
                                value="po"
                                v-model="formOFItem.usePriceType"
                              /><label
                                class="form-check-label"
                                for="use-price-po"
                                >ใช้ราคาตาม PO</label
                              >
                            </div>
                            <div>
                              <input
                                type="radio"
                                class="form-check-input"
                                id="use-price-new"
                                value="new"
                                v-model="formOFItem.usePriceType"
                              /><label
                                class="form-check-label"
                                for="use-price-new"
                                >ระบุราคาใหม่</label
                              >
                            </div>
                          </div>
                        </div> -->
                        <!-- ราคาต่อหน่วย -->
                        <div class="">
                          <label for="material-price" class="form-label"
                            >ราคาต่อหน่วย
                            <span class="text-theme-6">*</span></label
                          >
                          <input
                            type="number"
                            id="material-price"
                            class="form-control"
                            min="0"
                            :class="{
                              'border-theme-6':
                                validateItem.materialInfo.price.$error
                            }"
                            v-model.number="
                              validateItem.materialInfo.price.$model
                            "
                            @keyup="summaryAmount"
                            @change="summaryAmount"
                          />
                          <span
                            class="text-theme-6"
                            v-if="validateItem.materialInfo.price.$error"
                            >{{
                              validateItem.materialInfo.price.required.$message
                            }}</span
                          >
                        </div>
                        <!-- จำนวนหน่วย -->
                        <div class="">
                          <label for="material-quality" class="form-label"
                            >จำนวนหน่วย
                            <span class="text-theme-6">*</span></label
                          >
                          <input
                            type="number"
                            id="material-quality"
                            class="form-control"
                            min="0"
                            :class="{
                              'border-theme-6': validateItem.qty.$error
                            }"
                            v-model.number="validateItem.qty.$model"
                            @keyup="summaryAmount"
                            @change="summaryAmount"
                          />
                          <span
                            class="text-theme-6"
                            v-if="validateItem.qty.$error"
                            >{{ validateItem.qty.required.$message }}</span
                          >
                        </div>
                        <!-- ราคาก่อนรวมภาษี -->
                        <div class="">
                          <label for="material-amount" class="form-label"
                            >ราคาก่อนรวมภาษี
                            <span class="text-theme-6">*</span></label
                          >
                          <input
                            type="number"
                            id="material-amount"
                            class="form-control"
                            min="0"
                            :class="{
                              'border-theme-6': validateItem.amount.$error
                            }"
                            v-model.number="validateItem.amount.$model"
                            @keyup="calPriceQty"
                            @change="calPriceQty"
                          />
                          <span
                            class="text-theme-6"
                            v-if="validateItem.amount.$error"
                            >{{ validateItem.amount.required.$message }}</span
                          >
                        </div>
                        <!-- จำนวนรับที่ไม่ตรงกับหน่วยที่ตั้ง -->
                        <!-- <div class="">
                          <label for="material-quality" class="form-label"
                            >จำนวนรับที่ไม่ตรงกับหน่วยที่ตั้ง</label
                          >
                          <input
                            type="number"
                            id="material-quality"
                            class="form-control"
                            min="0"
                            v-model.number="formOFItem.qtyPoDiff"
                          />
                        </div> -->
                        <!-- ภาษีมูลค่าเพิ่ม -->
                        <div class="grid grid-cols-4 gap-4">
                          <!-- ภาษีมูลค่าเพิ่ม -->
                          <div class="col-span-2">
                            <label for="material-vat" class="form-label "
                              >ภาษีมูลค่าเพิ่ม</label
                            >
                            <input
                              type="number"
                              id="material-vat"
                              class="form-control col-span-3"
                              min="0"
                              v-model.number="formOFItem.vat"
                              @keyup="calVat"
                              @change="calVat"
                              :disabled="!formOFItem.taxVatProcess"
                            />
                          </div>
                          <!-- ภาษี -->
                          <div>
                            <label for="material-vat-per" class="form-label "
                              >ภาษี</label
                            >
                            <input
                              id="material-vat-per"
                              type="number"
                              class="form-control"
                              v-model.number="formOFItem.taxVatDefault"
                              min="0"
                              max="100"
                              @change="calVatProcess"
                            />
                          </div>
                          <div class="flex items-end">
                            <button
                              class="btn"
                              :class="[
                                formOFItem.taxVatProcess
                                  ? 'btn-primary'
                                  : 'btn-secondary'
                              ]"
                              @click="
                                ;[
                                  (formOFItem.taxVatProcess = !formOFItem.taxVatProcess),
                                  calVatProcess()
                                ]
                              "
                            >
                              คำนวณ
                            </button>
                          </div>
                        </div>
                        <!-- ภาษีหัก ณ ที่จ่าย -->
                        <div class="grid grid-cols-4 gap-4">
                          <!-- ภาษีหัก ณ ที่จ่าย -->
                          <div class="col-span-2">
                            <label for="material-wh" class="form-label "
                              >ภาษีหัก ณ ที่จ่าย</label
                            >
                            <input
                              type="number"
                              id="material-wh"
                              class="form-control col-span-3"
                              v-model.number="formOFItem.whTax"
                              min="0"
                              @keyup="calTax"
                              @change="calTax"
                              :disabled="!formOFItem.taxWhProcess"
                            />
                          </div>
                          <!-- ภาษี -->
                          <div>
                            <label for="material-vat-per" class="form-label "
                              >หัก</label
                            >
                            <input
                              id="material-vat-per"
                              type="number"
                              class="form-control"
                              v-model.number="formOFItem.whTaxDefault"
                              min="0"
                              max="100"
                              @change="calTaxProcess"
                            />
                          </div>
                          <div class="flex items-end">
                            <button
                              class="btn"
                              :class="[
                                formOFItem.taxWhProcess
                                  ? 'btn-primary'
                                  : 'btn-secondary'
                              ]"
                              @click="
                                ;[
                                  (formOFItem.taxWhProcess = !formOFItem.taxWhProcess),
                                  calTaxProcess()
                                ]
                              "
                            >
                              คำนวณ
                            </button>
                          </div>
                        </div>
                        <!-- Actual Cost -->
                        <!-- <div class="grid grid-cols-3 gap-4">
                          <div class="col-span-2">
                            <label for="material-actualCost" class="form-label"
                              >Actual Cost
                              <span class="text-theme-6">*</span></label
                            >
                            <input
                              type="number"
                              id="material-actualCost"
                              class="form-control"
                              min="0"
                              :class="{
                                'border-theme-6': validateItem.actualCost.$error
                              }"
                              v-model.number="validateItem.actualCost.$model"
                            />
                            <span
                              class="text-theme-6"
                              v-if="validateItem.actualCost.$error"
                              >{{
                                validateItem.actualCost.required.$message
                              }}</span
                            >
                          </div>
                          <div class="">
                            <label for="material-vat-per" class="form-label "
                              >แบ่งรับ %</label
                            >
                            <input
                              type="number"
                              id="material-actualCost-percent"
                              class="form-control"
                              min="0"
                              max="100"
                              v-model.number="formOFItem.percent"
                              @keyup="calActualCost"
                              @change="calActualCost"
                            />
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
                <!-- รายละเอียดงบประมาณ -->
                <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">รายละเอียดงบประมาณ</div>
                  <div class="">
                    <div class="mb-4 space-y-4">
                      <!-- ปีงบประมาณ -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">ปีงบประมาณ: </label>
                        <div>{{ formOFItem.budgetInfo.year }}</div>
                      </div>
                      <!-- รหัส BU -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">รหัส BU:</label>
                        <div>{{ formOFItem.budgetInfo.bu_code }}</div>
                      </div>
                      <!-- ชนิดงบประมาณ -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">ชนิดงบประมาณ:</label>
                        <div>{{ formOFItem.budgetInfo.bu_type }}</div>
                      </div>
                      <!-- ใช้งบประมาณของหน่วยงาน -->
                      <div
                        v-if="formOFItem.budgetInfo.subledger"
                        class="flex justify-between"
                      >
                        <label for="" class="font-bold"
                          >ใช้งบประมาณของโครงการ:</label
                        >
                        <div>{{ formOFItem.budgetInfo.subledger_name }}</div>
                      </div>
                      <div v-else class="flex justify-between">
                        <label for="" class="font-bold"
                          >ใช้งบประมาณของหน่วยงาน:</label
                        >
                        <div>{{ formOFItem.budgetInfo.bu_name }}</div>
                      </div>
                      <!-- Account Code -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Account Code:</label>
                        <div>{{ formOFItem.budgetInfo.account_code }}</div>
                      </div>
                      <!-- Subsidiary -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Subsidiary:</label>
                        <div>{{ formOFItem.budgetInfo.subsidiary }}</div>
                      </div>
                      <!-- Account Name -->
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Account Name:</label>
                        <div>{{ formOFItem.budgetInfo.account_name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- รายละเอียดด้านบัญชี -->
                <!-- <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">รายละเอียดภาษี</div>
                  <div class="">
                    <div class="mb-4 space-y-4">
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Tax Rate: </label>
                        <div>{{ getTaxRate(formOFItem.taxRate) }}</div>
                      </div>
                      <div class="flex justify-between">
                        <label for="" class="font-bold">GL Offset:</label>
                        <div>
                          {{
                            formOFItem.glOffset
                              ? formOFItem.glOffset
                              : 'ไม่ระบุ'
                          }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <label for="" class="font-bold">Cat Code:</label>
                        <div>{{ getCatCode(formOFItem.catCode) }}</div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
              <!-- <div>
                <div class="border p-5 rounded-lg">
                  <div class="text-lg mb-4">ประวัติการ GR</div>
                  <div class="">
                    <table class="table table--sm">
                      <thead>
                        <tr class="bg-gray-700 text-white">
                          <th class="whitespace-nowrap text-center" width="3%">
                            ลำดับ
                          </th>
                          <th class="whitespace-nowrap text-center" width="13%">
                            เลขที่ GR
                          </th>
                          <th class="whitespace-nowrap text-center" width="41%">
                            รายละเอียด
                          </th>
                          <th class="whitespace-nowrap text-center" width="5%">
                            จำนวนที่รับ
                          </th>
                          <th class="whitespace-nowrap text-center" width="10%">
                            หน่วยนับ
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            รวม
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            หัก ณ ที่จ่าย
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            Vat
                          </th>
                          <th class="whitespace-nowrap text-center" width="7%">
                            Actual Cost
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="text-center"
                          v-if="remain.history.length == 0"
                        >
                          <td colspan="9" class="border-b">ไม่พบรายการ</td>
                        </tr>
                        <tr
                          v-for="(rHistory, index) in remain.history"
                          :key="index"
                        >
                          <td class="text-center border-b-2">
                            {{ index + 1 }}.
                          </td>
                          <td class=" border-b-2">{{ rHistory.gr_no_full }}</td>
                          <td class="border-b-2">{{ rHistory.item_name }}</td>
                          <td class="text-right border-b-2">
                            {{ rHistory.qty }}
                          </td>
                          <td class="text-center border-b-2">
                            {{ rHistory.uom }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.amount) }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.wh_tax) }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.vat) }}
                          </td>
                          <td class="text-right border-b-2">
                            {{ numberFormat(rHistory.actual_cost) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> -->

              <!-- btn save and cancal -->
              <div class="mt-4 flex">
                <button
                  type="button"
                  class="btn btn-primary disabled:opacity-50 mr-2 flex items-center"
                  @click.prevent="updateItem()"
                  :disabled="btnItemSave.disabled"
                  v-show="!btnItemSave.hide"
                >
                  <FileTextIcon
                    class="w-4 h-4 mr-2"
                    v-if="!btnItemSave.loading"
                  />
                  <LoadingIcon
                    icon="oval"
                    color="blue"
                    v-else
                    class="w-4 h-4 mr-2"
                  />
                  Save
                </button>
                <button class="btn ml-2" @click="clearFormItem()">
                  <Trash2Icon class="w-4 h-4 mr-2" />Cancel
                </button>
              </div>
            </div>
          </div>

          <!-- รายการเบิก -->
          <div class="grid grid-cols-1 mt-5">
            <div class="box p-5">
              <div class="md:flex md:justify-between pb-4">
                <div class="flex">
                  <div class="text-lg font-bold">รายการสินค้า</div>
                  <OverBudget />
                </div>
                <div class="text-right mt-2 md:mt-0">
                  <button
                    class="btn btn-outline-primary ml-2"
                    type="button"
                    @click.stop="checkBudget()"
                  >
                    <CheckCircleIcon class="w-4 h-4 mr-2 hidden md:block" />
                    ตรวจสอบงบประมาณ
                  </button>
                </div>
              </div>
              <!-- table -->
              <div class="overflow-x-scroll">
                <table class="table table--sm">
                  <thead>
                    <tr class="bg-gray-700 text-white">
                      <th class="whitespace-nowrap text-center" width="3%">
                        ลำดับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="10%">
                        เลขที่เอกสาร
                      </th>
                      <th class="whitespace-nowrap text-center" width="20%">
                        รายละเอียดสินค้า
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        หน่วยนับ POS
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ราคาต่อหน่วย<br />(ไม่รวมภาษี)
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        จำนวนสินค้า
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        หน่วยนับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ราคา<br />ก่อนรวมภาษี
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        ภาษี<br />มูลค่าเพิ่ม
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        หัก ณ ที่จ่าย
                      </th>
                      <th class="whitespace-nowrap text-center" width="7%">
                        รวมเป็นเงิน<br />ทั้งหมด
                      </th>
                      <th class="whitespace-nowrap text-center" width="10%">
                        สถานที่รับ
                      </th>
                      <th class="whitespace-nowrap text-center" width="5%">
                        จัดการ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center" v-if="items.length == 0">
                      <td colspan="10" class="border-b">ไม่พบรายการ</td>
                    </tr>
                    <tr
                      v-for="(item, inx) in items"
                      :key="item.rf_item_id"
                      v-else
                    >
                      <td class="border-b-2 text-center">{{ inx + 1 }}.</td>
                      <td class="border-b-2 text-center">
                        {{ item.doc_no_full }}
                      </td>
                      <td
                        class="border-b-2"
                        v-html="
                          item.item_name
                            ? item.item_name.replaceAll('\n', '<br/>')
                            : ''
                        "
                      ></td>
                      <td class="text-right border-b-2">
                        {{ item.qty_pos }} {{ item.stock_unit_name }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.unit_price) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.qty) }}
                      </td>
                      <td class="text-center border-b-2">{{ item.uom }}</td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.amount) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.vat) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.wh_tax) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ numberFormat(item.actual_cost) }}
                      </td>
                      <td class="text-right border-b-2">
                        {{ item.pickup_loc }}
                      </td>
                      <td class="text-right border-b-2">
                        <div>
                          <button
                            class="btn btn-sm"
                            :class="[
                              item.is_edit
                                ? 'btn-warning'
                                : 'btn-outline-warning'
                            ]"
                            @click="getOFItem(item.of_item_id, inx)"
                          >
                            <EditIcon class="w-4 h-4" />
                          </button>
                          <a
                            href="javascript:;"
                            class="btn btn-sm btn-danger ml-2"
                            data-toggle="modal"
                            data-target="#delete-pv-item-modal-preview"
                            @click="setDeleteOFItem(item.of_item_id)"
                            v-show="!formRF.rfEdit"
                          >
                            <Trash2Icon class="w-4 h-4" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ประเภทของงบประมาณ -->
          <div class="grid lg:grid-cols-2 gap-0 lg:gap-4">
            <div class="mt-5">
              <TableSummaryCost :items="formOF.itemSummary" />
            </div>
            <div class="mt-5" v-if="formOF.poEdit">
              <TableHistory :items="formOF.historyArray" />
            </div>
          </div>

          <!-- BEGIN: Modal Content -->
          <div
            id="delete-pv-item-modal-preview"
            class="modal"
            tabindex="-1"
            data-backdrop="static"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-body p-0">
                  <div class="p-5 text-center">
                    <XCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
                    <div class="text-3xl mt-5">คุณแน่ใจ</div>
                    <div class="text-gray-600 mt-2">
                      ต้องการลบรายการนี้ ใช่ หรือ ไม่?
                    </div>
                  </div>
                  <div class="px-5 pb-8 text-center">
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1"
                      @click="cancelDeleteRFItem()"
                    >
                      ไม่
                    </button>
                    <button
                      type="button"
                      data-dismiss="modal"
                      class="btn btn-danger w-24"
                      @click="confirmDeleteRFItem()"
                    >
                      ใช่
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Modal Content -->
          <!-- BEGIN: Modal Content -->
          <ModalCancel
            module="preorder"
            doc-type="rf"
            :doc-id="formRF.rfID"
            redirect-complete="preorderRFList"
          />
          <!-- END: Modal Content -->
        </div>
        <!-- BEGIN: Modal PR -->
        <div
          id="modal-of-list"
          class="modal"
          tabindex="-1"
          data-backdrop="static"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-body p-10 text-center">
                <TableListSelectedOF
                  title="OF or Vendor"
                  :data="ofList"
                  :hasOption="true"
                  :fieldOptions="{
                    label: 'doc_no_full',
                    value: 'of_id'
                  }"
                  :btnConfirm="true"
                  :btnClosed="true"
                  :itemsSelected="items"
                  :displayStatus="modalOFDisplay"
                  :vendorInOFOptions="vendorInOFOptions"
                  @confirm="confirmOF"
                  @closed="closedModalOFList"
                />
                <!-- :mainSelected="ofChosen" -->
              </div>
            </div>
          </div>
        </div>
        <!-- END: Modal PR -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  reactive,
  computed,
  onUnmounted,
  onMounted,
  ref,
  toRefs,
  watch
} from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { api } from '@/utils/api'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import alert from '@/helpers/alert'
import helpers from '@/helpers'

import OverBudget from '@/components/overBudget.vue'
import WfSelectSingleEmployee from '@/components/select-single-employee/Main.vue'
// import TableMaterial from '@/components/table-material/Main.vue'
import TableListSelectedOF from '@/components/table-list-selected/Of.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import AttachFileUpload from '@/components/attach-file/Upload.vue'
// import DetailShipping from '@/components/DetailShipping.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import ModalCancel from '@/components/ModalCancel.vue'
import TextEditor from '@/components/TextEditor.vue'
import MemoAutoComplete from '@/components/MemoAutoComplete.vue'
import WfSelectSinglePayee from '@/components/select-single-payee/Main.vue'
import dayjs from 'dayjs'
// import WfSelectSingleVendor from '@/components/select-single-vendor/Main.vue'

export default {
  components: {
    OverBudget,
    WfSelectSingleEmployee,
    // TableMaterial,
    TableSummaryCost,
    AttachFilePreview,
    AttachFileUpload,
    TableHistory,
    TableListSelectedOF,
    // DetailShipping,
    DocumentPath,
    ModalCancel,
    TextEditor,
    MemoAutoComplete,
    WfSelectSinglePayee
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const documentPath = computed(() => store.state.rf.documentPath)
    const btnCancel = computed(() => store.state.rf.btnCancel)
    const btnSave = computed(() => store.state.rf.btnSave)
    const btnDraft = computed(() => store.state.rf.btnDraft)
    const btnReject = computed(() => store.state.rf.btnReject)
    const btnItemSave = computed(() => store.state.rf.btnItemSave)
    // const instalmentOptions = computed(() => store.state.rf.grInstalmentType)
    // const instalmentNo = computed(() => store.state.rf.grInstalmentNo)
    // const instalmentDefault = computed(
    //   () => store.state.rf.grInstalmentTypeDefault
    // )
    const userInfo = computed(() => store.state.auth.info)

    const companyOptions = computed(() => store.state.global.company)
    const companyDefault = computed(() => store.state.global.companyDefault)
    const employeeDefault = computed(() => store.state.global.employeeDefault)
    const currencyOptions = computed(() => store.state.global.currency)
    // const cashOptions = computed(() => store.state.global.cash)
    // const memoOptions = computed(() => store.state.rf.memo)
    const orderTypeOptions = computed(() => store.state.rf.orderType)
    const ofList = computed(() => store.state.rf.ofList)
    const vendorInOFOptions = computed(() => store.state.rf.vendorInOFList)
    const ofChosen = ref([])
    const docNoFull = ref(null)
    const itemIndex = ref(null)
    // const remain = reactive({
    //   sumActualCost: 0,
    //   instalmentLatest: 0,
    //   remainActualCost: 0,
    //   history: []
    // })
    // const shippingRecipientOption = computed(
    //   () => store.state.of.shippingRecipientOption
    // )
    // const shippingConditionPaymentOption = computed(
    //   () => store.state.of.shippingConditionPaymentOption
    // )

    const memoOptions = ref([])
    const { numberFormat, numberFormat2, dateFormat, fillBorderColor } = helpers
    const fileUploadMaxSize = computed(
      () => store.state.global.fileUploadMaxSize
    )
    // const resValidator = ref(null)

    const uomOptions = computed(() => store.getters['global/getUOMOptions'])
    const documentSpacialPathOptions = computed(
      () => store.state.global.documentSpacialPath
    )
    const isLoadingRFList = ref(false)
    const files = ref([])

    const documentPathText = computed(() => store.state.rf.documentPathText)

    const selectedMemo = ref(null)

    // const rulesPO = {
    //   shippingAddress: { required },
    //   shippingRecipient: { required },
    //   shippingConditionSendSelected: { required },
    //   shippingConditionPaymentSelected: { required },
    //   shippingCheckBy: { required },
    //   shippingDate: { required }
    // }

    const formOF = reactive({
      // currencyCode: '',
      // ememoId: '',
      // ememoTitle: '',
      // ememoLink: '',
      ememo: {
        id: null,
        title: null,
        link: null
      },
      detail: '',
      orderTypeText: '',
      itemSummary: [],
      historyArray: [],
      statusCode: null,
      docNoFull: '',
      prDocNoFull: '',

      vendorSelectedEdit: null,
      vendorCodeEdit: '',
      vendorNameEdit: '',
      vendorAddressEdit: '',
      vendorSelected: null,

      vendorCode: '',
      vendorName: '',
      vendorAddress: '',
      vendorEmail: '',
      vendorTelephone: '',

      // reasonChosenVendor: '',
      // poDocTypeText: '',
      // discountAllItem: null,

      // shippingAddress: '',
      // shippingRecipient: '',
      // shippingConditionSend: null,
      // shippingConditionPayment: null,
      // shippingCheckBy: '',
      // shippingDate: '',
      // shipping: {
      //   date: '',
      //   address: '',
      //   recipient: '',
      //   conditionSend: '',
      //   conditionPayment: '',
      //   checkBy: ''
      // },
      orderTypeSelected: null
      // importantFactor: ''
    })

    const formRF = reactive({
      rfID: route.params.id || null,
      isEdit: route.params.id || null,
      rfEdit: route.params.id !== undefined,
      companySelected: store.state.auth.info.comp_no,
      telephone: store.state.global.employeeDefault.telephone,
      employeeSelected: store.state.auth.info.employeeId,
      invoiceNo: '',
      invoiceDate: '',
      // instalmentType: instalmentDefault.value,
      // instalmentNo: 1,
      specialPath: null,
      documentPath: [],
      glDate: '',
      reqDetail: '',
      reqName: '',
      reqId: '',
      reqDate: '',
      ofId: null,
      docNoFull: '',
      approveResultArray: [],
      documentPathArray: [],
      nextStatus: '',
      statusCode: null,
      currencySelected: store.state.global.currencyDefault,
      orderTypeSelected: store.state.rf.orderTypeDefault,
      memoSelected: null,
      payeeSelected: null,
      payeeName: null,
      payeeNo: null
    })

    const rulesRF = {
      invoiceNo: { required },
      invoiceDate: { required },
      reqDate: { required },
      reqDetail: { required },
      telephone: { required }
    }

    const validateRF = useVuelidate(rulesRF, toRefs(formRF))

    // watch([instalmentDefault, instalmentNo], newVal => {
    //   // console.log('watch instalmentDefault: ', newVal)
    //   formRF.instalmentType = newVal[0]
    //   formRF.instalmentNo = newVal[1]
    //   if (newVal[0] != 'm') {
    //     formRF.instalmentNo = 1
    //   }
    // })

    // watch(
    //   () => formRF.instalmentType,
    //   newVal => {
    //     // console.log('watch instalmentType: ', newVal)
    //     store.commit('rf/setGrInstalmentTypeDefault', newVal)
    //     if (newVal == 'm') {
    //       store.dispatch('rf/loadGrOptionInstalmentNo', {
    //         ofId: formRF.ofId,
    //         rfId: formRF.rfID
    //       })
    //     }
    //   }
    // )

    watch(
      () => store.state.rf.orderTypeDefault,
      () => {
        formOF.orderTypeSelected = store.state.rf.orderTypeDefault
      }
    )

    // const setOF = data => {
    //   formOF.vendorCode = data.vendor_code
    //   formOF.vendorName = data.vendor_name
    //   formOF.vendorAddress = data.vendor_address
    //   formOF.vendorTelephone = data.vendor_telephone
    //   formOF.vendorEmail = data.vendor_email
    //   formOF.poDocTypeText = data.po_doc_type_text
    //   formOF.reasonChosenVendor = data.reason_chosen_vendor
    //   formOF.currencyCode = data.currency_code
    //   formOF.orderTypeText = data.order_type_text
    //   formOF.memoSelected = data.ememo_id
    //   formOF.detail = data.req_detail

    //   formOF.shipping.address = data.shipping_address
    //   formOF.shipping.recipient = data.shipping_recipient
    //   formOF.shipping.conditionSend = data.shipping_condition_send
    //   formOF.shipping.conditionPayment = data.payment_term_name
    //   formOF.shipping.checkBy = data.shipping_check_by
    //   formOF.shipping.date = data.shipping_date

    //   if (data.ememo_id != 0 && data.ememo_id != null) {
    //     formOF.ememo.id = data.ememo_id
    //     formOF.ememo.title = data.ememo_title
    //     formOF.ememo.link = `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${data.ememo_id}/detail`
    //   }

    //   formOF.docNoFull = data.doc_no_full
    //   formOF.prDocNoFull = data.pr_doc_no_full
    //   formOF.importantFactor = data.important_factor
    //   files.value = data.file_attach_array

    //   formRF.ofId = data.of_id
    // }

    // const setOFItem = data => {

    // }

    const items = ref([])
    const modalOFDisplay = ref('hide')
    const openModalOFList = () => {
      modalOFDisplay.value = 'open'
    }
    const closedModalOFList = () => {
      modalOFDisplay.value = 'hide'
    }

    const ofHeaderFormat = data => {
      const chosen = ref([])
      chosen.value = data.chosen.map(tmp => {
        return {
          of_id: tmp.of_id,
          of_no: tmp.of_no,
          of_comp: tmp.of_comp,
          doc_no_full: tmp.doc_no_full,
          req_detail: tmp.req_detail,
          doc_title: tmp.doc_title,
          req_date: tmp.req_date,
          req_date_text: tmp.req_date_text,
          currency_code: tmp.currency_code,
          bu_no: tmp.bu_no,
          bu_name: tmp.bu_name,
          telephone: tmp.telephone,
          file_attach: tmp.file_attach,
          file_attach_array: tmp.file_attach_array,
          ememo_id: tmp.ememo_id,
          ememo_title: tmp.ememo_title,
          ememo_link: tmp.ememo_id
            ? `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${tmp.ememo_id}/detail`
            : null,
          reason_chosen_vendor: tmp.reason_chosen_vendor,
          order_type_text: tmp.order_type_text,
          selected: tmp.selected
        }
      })
      confirmOF({
        chosen: chosen.value,
        chosenItems: data.chosenItems
      })
    }

    const confirmOF = data => {
      if (data.chosenItems.length) {
        isLoadingRFList.value = true
        // setOF(data.chosen)
        // docNoFull.value = data.chosen.doc_no_full
        items.value = data.chosenItems
        ofChosen.value = data.chosen

        if (data.chosen) {
          const memoAllOF = data.chosen
            .filter(h => h.ememo_id != null)
            .map(h => {
              const title = h.ememo_title.split(' - ')
              return {
                id: h.ememo_id,
                doc_no: '',
                doc_no_full: title[0], // h.ememo_title,
                title: title[1],
                doc_owner: ''
              }
            })

          memoOptions.value = []
          memoOptions.value.push({
            label: 'Memo all OF',
            items: memoAllOF
          })

          const orderType = orderTypeOptions.value.find(
            t => t.label == data.chosen[0].order_type_text
          )
          if (orderType) {
            formRF.orderTypeSelected = orderType.value
          }
        }

        if (items.value.length > 0) {
          formOF.vendorCode = items.value[0].vendor_code
          formOF.vendorName = items.value[0].vendor_name
          formOF.vendorAddress = items.value[0].vendor_address
          formOF.vendorEmail = items.value[0].vendor_email
          formOF.vendorTelephone = items.value[0].vendor_telephone
        }

        formRF.glDate = dayjs().format('YYYY-MM-DD')
        formRF.reqDate = dayjs().format('YYYY-MM-DD')
        formRF.invoiceDate = dayjs().format('YYYY-MM-DD')

        // if (!formRF.rfEdit) {
        //   store.dispatch('rf/loadDocumentPath', {
        //     compNo: companyDefault.value.comp_no,
        //     employeeId: formRF.employeeSelected
        //   })
        // }
      } else {
        isLoadingRFList.value = false
      }
    }

    const specialPathSelected = ref(null)
    // watch(specialPathSelected, newVal => {
    //   store.dispatch('rf/loadDocumentPath', {
    //     compNo: companyDefault.value.comp_no,
    //     employeeId: formRF.employeeSelected,
    //     specialPath: newVal
    //   })
    // })

    const boxItemOpen = ref(false)
    const toggleBoxItemOpen = () => {
      clearFormItem()
      boxItemOpen.value = !boxItemOpen.value
    }

    const deleteOFItemID = ref(null)
    const setDeleteOFItem = id => {
      deleteOFItemID.value = id
    }
    const cancelDeleteRFItem = () => {
      deleteOFItemID.value = null
    }
    const confirmDeleteRFItem = async () => {
      const delItems = items.value.find(
        item => item.of_item_id === deleteOFItemID.value
      )
      if (delItems) {
        if (delItems.rf_item_id) {
          await api
            .delete(`/preorder/rf/deleteItem/${delItems.rf_item_id}`)
            .then(res => {
              if (res.code == 200) {
                items.value.map(item => {
                  if (item.of_item_id === deleteOFItemID.value) {
                    item.rf_item_id = null
                  }
                  return item
                })
                const newItems = items.value.filter(
                  item => item.of_item_id !== deleteOFItemID.value
                )
                items.value = newItems
                deleteOFItemID.value = null
                alert.success()
              } else {
                alert.error(res.message)
              }
            })
            .catch(e => {
              alert.error(e.message)
            })
        } else {
          const newItems = items.value.filter(
            item => item.of_item_id !== deleteOFItemID.value
          )
          items.value = newItems
          deleteOFItemID.value = null
          alert.success()
        }
      } else {
        alert.error('ไม่พบข้อมูล')
      }
    }

    const formOFItem = reactive({
      // prItemID: null,
      ofItemID: null,
      budgetSelected: null,
      materialSelected: null,
      budgetInfo: {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      },
      budgetSubledgerSelected: null,
      bu_year: null,
      bu_name: null,
      uom: null,
      uomSelected: null,
      qtyPos: 0,
      useDate: '',
      pickupLoc: '',
      amount: 0,
      qty: 0,
      actualCost: 0,
      actualCostTmp: 0,
      vat: 0,
      taxVatDefault: 7,
      taxVatProcess: true,
      whTaxDefault: 3,
      whTax: 0,
      taxWhProcess: false,
      materialInfo: {
        account_code: null,
        all_unit: null,
        base_unit: null,
        business_unit_code: null,
        stockUnitName: null,
        description: '',
        description_code: '',
        gl_category: '',
        it_item: null,
        material_code: '',
        material_group: '',
        material_type: '',
        order_unit: '',
        plant: null,
        power_unit_no: null,
        price: null,
        primary_unit: '',
        purchase_group: null,
        secondary_unit: '',
        storage_location: null,
        subsidiary: null,
        update_date: null
      },
      // taxRate: null,
      // glOffset: null,
      // catCode: null,
      bargainDiscount: '',
      usePriceType: 'rf',
      // qtyPoDiff: 0,
      percent: 0
    })

    const summaryAmount = () => {
      if (formOFItem.materialInfo.price > 0) {
        // formOFItem.amount + formOFItem.vat - formOFItem.whTax
        formOFItem.amount = parseFloat(
          numberFormat2(formOFItem.materialInfo.price * formOFItem.qty)
        )
      } else {
        formOFItem.amount = 0
      }
      calPriceQty()
    }

    const calPriceQty = () => {
      // if (formOFItem.materialInfo.price > 0) {
      // formOFItem.amount = formOFItem.materialInfo.price * formOFItem.qty
      calVatProcess()
      calTaxProcess()
      // }
    }

    const calVat = () => {
      formOFItem.actualCost = numberFormat2(
        formOFItem.amount + formOFItem.vat - formOFItem.whTax
      )
      // calActualCost()
    }

    const calTax = () => {
      formOFItem.actualCost = numberFormat2(
        formOFItem.amount + formOFItem.vat - formOFItem.whTax
      )
      // calActualCost()
    }

    const calVatProcess = () => {
      if (formOFItem.taxVatProcess) {
        if (formOFItem.taxVatDefault > 0 && formOFItem.taxVatDefault <= 100) {
          formOFItem.vat = parseFloat(
            numberFormat2((formOFItem.amount * formOFItem.taxVatDefault) / 100)
          )
        } else {
          formOFItem.vat = 0
        }
      } else {
        formOFItem.vat = 0
      }
      calVat()
    }

    const calTaxProcess = () => {
      if (formOFItem.taxWhProcess) {
        if (formOFItem.whTaxDefault > 0 && formOFItem.whTaxDefault <= 100) {
          formOFItem.whTax = parseFloat(
            numberFormat2((formOFItem.amount * formOFItem.whTaxDefault) / 100)
          )
        } else {
          formOFItem.whTax = 0
        }
      } else {
        formOFItem.whTax = 0
      }
      calTax()
    }

    // const calActualCost = () => {
    //   // console.log('percent: ', formOFItem.percent)
    //   formOFItem.actualCostTmp =
    //     formOFItem.amount + formOFItem.vat - formOFItem.whTax
    //   if (formOFItem.percent > 0 && formOFItem.percent <= 100) {
    //     formOFItem.actualCost = numberFormat2(
    //       (formOFItem.actualCostTmp * formOFItem.percent) / 100
    //     )
    //     // } else {
    //     //   formOFItem.actualCost = formOFItem.actualCostTmp
    //   }
    // }

    const rulesItem = {
      materialInfo: {
        description: { required },
        price: { required }
      },
      pickupLoc: { required },
      qty: { required },
      amount: { required },
      uomSelected: { required },
      // qtyPos: { requiredIf: value => value > 0 },
      useDate: { required },
      actualCost: { required }
    }

    const validateItem = useVuelidate(rulesItem, toRefs(formOFItem))

    const setBudget = val => {
      formOFItem.budgetInfo.year = val.year
      formOFItem.budgetInfo.bu_code = val.bu_code
      formOFItem.budgetInfo.bu_name = val.bu_name
      formOFItem.budgetInfo.subsidiary = val.subsidiary
      formOFItem.budgetInfo.subledger = val.subledger
      formOFItem.budgetInfo.account_code = val.account_code
      formOFItem.budgetInfo.account_name = val.account_name
      formOFItem.budgetInfo.subledger_name = val.subledger_name
      formOFItem.budgetInfo.bu_type = val.subledger
        ? 'งบประมาณโครงการ'
        : 'งบประมาณหน่วยงาน'
    }

    // const setMaterial = val => {
    //   formOFItem.materialInfo.account_code = val.account_code
    //   formOFItem.materialInfo.all_unit = val.all_unit
    //   formOFItem.materialInfo.base_unit = val.base_unit
    //   formOFItem.materialInfo.business_unit_code = val.business_unit_code
    //   formOFItem.materialInfo.description = val.description
    //   formOFItem.materialInfo.description_code = val.description_code
    //   formOFItem.materialInfo.gl_category = val.gl_category
    //   formOFItem.materialInfo.it_item = val.it_item
    //   formOFItem.materialInfo.material_code = val.material_code
    //   formOFItem.materialInfo.material_group = val.material_group
    //   formOFItem.materialInfo.material_type = val.material_type
    //   formOFItem.materialInfo.order_unit = val.order_unit
    //   formOFItem.materialInfo.plant = val.plant
    //   formOFItem.materialInfo.power_unit_no = val.power_unit_no
    //   formOFItem.materialInfo.price = val.price
    //   formOFItem.materialInfo.primary_unit = val.primary_unit
    //   formOFItem.materialInfo.purchase_group = val.purchase_group
    //   formOFItem.materialInfo.secondary_unit = val.secondary_unit
    //   formOFItem.materialInfo.storage_location = val.storage_location
    //   formOFItem.materialInfo.subsidiary = val.subsidiary
    //   formOFItem.materialInfo.update_date = val.update_date
    // }

    // const companyChange = () => {
    //   store.commit('global/setCompanyDefault', { no: formRF.companySelected })
    // }

    // watch(
    //   () => formOF.vendorSelected,
    //   newVal => {
    //     console.log('watch: ', newVal)
    //     if (newVal) {
    //       if (formOF.poEdit) {
    //         if (newVal.vendor_code == formOF.vendorSelectedEdit) {
    //           formOF.vendorName = formOF.vendorNameEdit
    //           formOF.vendorCode = formOF.vendorCodeEdit
    //           formOF.vendorAddress = formOF.vendorAddressEdit
    //         } else {
    //           formOF.vendorName = newVal.vendor_name
    //           formOF.vendorCode = newVal.vendor_code
    //           formOF.vendorAddress = newVal.vendor_address
    //         }
    //       } else {
    //         formOF.vendorName = newVal.vendor_name
    //         formOF.vendorCode = newVal.vendor_code
    //         formOF.vendorAddress = newVal.vendor_address
    //       }
    //     }
    //   }
    // )

    const onChangeDocumentPath = async data => {
      // items.value = []
      // ofChosen.value = []
      docNoFull.value = ''
      console.log('target:', data.target, specialPathSelected.value)
      // console.log('on change docu path: ', isLoadingRFList.value)
      // isLoadingRFList.value = false
      // console.log('change: ', data.target)

      // store.commit('rf/setDocumentPath', [])
      // store.commit('rf/setDocumentPathText', [])

      // if (data.target == 'select-company' || data.target == 'mounted') {
      if (data.target == 'select-company') {
        // console.log('formRF.companySelected: ', formRF.companySelected)
        store.commit('global/setCompanyDefault', { no: formRF.companySelected })
        specialPathSelected.value = null
        isLoadingRFList.value = false
        items.value = []
        ofChosen.value = []
      }

      if (
        data.target == 'select-single-employee' ||
        data.target == 'select-company'
      ) {
        // loading special path option
        await store.dispatch('global/loadDocumentSpacialPath', {
          compNo: companyDefault.value.comp_no
        })
        specialPathSelected.value = null
        formRF.telephone = store.state.global.employeeDefault.telephone
      }

      // if (data.target == 'select-company') {
      store.dispatch('rf/loadDocumentPath', {
        compNo: formRF.companySelected,
        employeeId: formRF.employeeSelected,
        specialPath: specialPathSelected.value
      })
      // }

      store.dispatch('rf/loadOFList', {
        employeeId: formRF.employeeSelected,
        company: formRF.companySelected
      })
    }

    watch(
      () => employeeDefault.value,
      newVal => {
        // console.log('watch employee default:', formRF.telephone, newVal)
        if (!formRF.rfEdit) {
          // formRF.telephone = newVal.telephone
        }
      }
    )

    const saveRF = async isDraft => {
      // disabled and loading
      validateRF.value.$touch()
      if (!validateRF.value.$invalid) {
        if (isDraft) {
          store.commit('rf/setBtnActiveFix', { type: 'btnDraft', status: true })
        } else {
          store.commit('rf/setBtnActiveFix', { type: 'btnSave', status: true })
        }
        validateRF.value.$reset()

        const dataRF = {
          is_draft: isDraft,
          username: userInfo.value.fullname,
          employee_id: userInfo.value.employeeId,
          rf_comp: formRF.companySelected,
          req_date: dateFormat(formRF.reqDate),
          req_id: employeeDefault.value.employee_id,
          req_name: employeeDefault.value.fullname_th,
          req_detail: fillBorderColor(formRF.reqDetail),
          telephone: formRF.telephone,
          // of_id: formRF.ofId,
          owner_id: userInfo.value.employeeId,
          owner_name: userInfo.value.fullname,
          invoice_no: formRF.invoiceNo,
          invoice_date: dateFormat(formRF.invoiceDate),
          // instalment_type: formRF.instalmentType,
          // instalment_no: formRF.instalmentNo,
          special_path: specialPathSelected.value,
          gl_date: dateFormat(formRF.glDate),
          file_attach: await store.getters['rf/getFileAttach'],
          document_path: documentPath.value,

          bu_no: employeeDefault.value.bu_no,
          bu_name: employeeDefault.value.bu_name,
          ememo_id: selectedMemo.value ? selectedMemo.value.id : null,
          ememo_title: selectedMemo.value
            ? `${selectedMemo.value.doc_no_full} - ${selectedMemo.value.title}`
            : null,
          currency_code: formRF.currencySelected,
          currency_ex: null,
          order_type: formRF.orderTypeSelected,
          payee_no: formRF.payeeSelected
            ? formRF.payeeSelected.vendor_code
            : null,
          payee_name: formRF.payeeSelected
            ? formRF.payeeSelected.vendor_name
            : null
        }

        if (!formRF.rfEdit) {
          await api
            .post('/preorder/rf/insert', dataRF)
            .then(async res => {
              if (res.code == 200) {
                formRF.rfID = res.data.rf_id
                formRF.rfEdit = true
                await saveItem()
                // alertBudget(false, res.data.is_over_budget)
                alert.success()
                store.commit('rf/setBtnDisplay', {
                  key: 'btnCancel',
                  status: true
                })
                store.commit('rf/setBtnDisplay', {
                  key: 'btnSave',
                  status: true
                })
              } else {
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
                alert.validatorShowData(res)
                return
              }
              if (isDraft) {
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                router.push({
                  name: 'preorderRFFormDetail',
                  params: { id: res.data.rf_id }
                })
              }
            })
            .catch(e => {
              alert.error(e.message)
              if (isDraft) {
                store.commit('po/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                store.commit('po/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
              }
            })
        } else {
          await api
            .put(`/preorder/rf/update/${formRF.rfID}`, dataRF)
            .then(async res => {
              if (res.code == 200) {
                alert.success()
              } else {
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
                // alert.error(res.message)
                alert.validatorShowData(res)
                return
              }
              if (isDraft) {
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                router.push({
                  name: 'preorderRFFormDetail',
                  params: { id: formRF.rfID }
                })
              }
            })
            .catch(e => {
              alert.error(e.message)
              if (isDraft) {
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnDraft',
                  status: false
                })
              } else {
                store.commit('rf/setBtnActiveFix', {
                  type: 'btnSave',
                  status: false
                })
              }
            })
        }
      } else {
        alert.error()
      }
    }

    const clearFormItem = () => {
      // validateItem.value.$reset()
      boxItemOpen.value = false
      // if (formOFItem.poItemID !== null) {
      for (const i in items.value) {
        items.value[i].is_edit = false
      }
      // }
      formOFItem.poItemID = null
      formOFItem.prItemID = null
      formOFItem.budgetSelected = null
      formOFItem.materialSelected = null

      formOFItem.budgetInfo = {
        year: '',
        bu_name: '',
        bu_code: '',
        bu_type: '',
        subledger: '',
        subsidiary: '',
        account_code: '',
        account_name: '',
        subledger_name: ''
      }
      formOFItem.useDate = ''
      formOFItem.pickupLoc = ''
      formOFItem.budgetSubledgerSelected = null
      formOFItem.bu_year = null
      formOFItem.bu_name = null
      formOFItem.uom = null
      formOFItem.uomSelected = null
      formOFItem.stockUnitName = ''
      formOFItem.amount = 0
      formOFItem.vat = 0
      formOFItem.actualCost = 0
      formOFItem.actualCostTmp = 0
      formOFItem.taxVatDefault = 7
      formOFItem.materialInfo = {
        account_code: null,
        all_unit: null,
        base_unit: null,
        business_unit_code: null,
        description: '',
        description_code: '',
        gl_category: '',
        it_item: null,
        material_code: '',
        material_group: '',
        material_type: '',
        order_unit: '',
        plant: null,
        power_unit_no: null,
        price: null,
        primary_unit: '',
        purchase_group: null,
        secondary_unit: '',
        storage_location: null,
        subsidiary: null,
        update_date: null,
        qtyPos: 0
      }
      // formOFItem.taxRate = null
      // formOFItem.glOffset = null
      // formOFItem.catCode = null
      formOFItem.bargainDiscount = ''
      formOFItem.usePriceType = 'rf'
      formOFItem.qtyPoDiff = 0
      formOFItem.taxVatProcess = true
      formOFItem.whTaxDefault = 3
      formOFItem.whTax = 0
      formOFItem.taxWhProcess = false

      // remain.sumActualCost = 0
      // remain.instalmentLatest = 0
      // remain.remainActualCost = 0
      // remain.history = []
    }

    const setDataItem = i => {
      return {
        rf_id: formRF.rfID,
        of_id: items.value[i].of_id,
        of_item_id: items.value[i].of_item_id,
        use_price_type: items.value[i].use_price_type,
        pickup_loc: items.value[i].pickup_loc,
        use_date: items.value[i].use_date,
        unit_price: items.value[i].unit_price,
        qty: items.value[i].qty,
        amount: items.value[i].amount,
        vat_rate: items.value[i].vat_rate,
        vat: items.value[i].vat,
        wh_tax_rate: items.value[i].wh_tax_rate,
        wh_tax: items.value[i].wh_tax,
        actual_cost: items.value[i].actual_cost,
        // qty_of_diff: items.value[i].qty_po_diff,
        uom: items.value[i].uom,
        uom_code: items.value[i].uom_code,
        stock_unit_name: items.value[i].stock_unit_name,
        qty_pos: items.value[i].qty_pos,
        unit_conversion_pos: items.value[i].unit_conversion_pos,
        item_stock_qty_pos: items.value[i].item_stock_qty_pos,
        item_stock_unit_pos: items.value[i].item_stock_unit_pos

        // item_type: items.value[i].item_type,
        // item_name: items.value[i].item_name,
        // item_code: items.value[i].item_code,
        // item_no: items.value[i].item_no,
        // item_category: items.value[i].item_category,

        // budget_bu_code: items.value[i].budget_bu_code,
        // budget_bu_name: items.value[i].budget_bu_name,
        // budget_bu_req_code: items.value[i].budget_bu_req_code,
        // budget_bu_req_name: items.value[i].budget_bu_req_name,
        // budget_group_code: items.value[i].budget_group_code,
        // budget_group_name: items.value[i].budget_group_name,
        // budget_subledger: items.value[i].budget_subledger,
        // budget_subledger_name: items.value[i].budget_subledger_name,
        // budget_subsidiary: items.value[i].budget_subsidiary,
        // budget_type: items.value[i].budget_type,
        // budget_name: items.value[i].budget_name,
        // budget_code: items.value[i].budget_code,
        // budget_year: items.value[i].budget_year,
        // tax_rate: items.value[i].tax_rate,
        // gl_offset: items.value[i].gl_offset,
        // cat_code: items.value[i].cat_code,
        // bargain_discount: items.value[i].bargain_discount
        // wh_tax: items.value[i].wh_tax,
        // wh_tax_rate: items.value[i].wh_tax_rate
      }
    }

    const saveItem = async () => {
      // const hasError = ref(false)
      let recheckBudget = false
      for (const i in items.value) {
        const data = await setDataItem(i)
        if (items.value[i].rf_item_id === null) {
          await api
            .post('/preorder/rf/insertItem', data)
            .then(async res => {
              if (res.code == 200) {
                alert.success()
                items.value[i].rf_item_id = res.data.rf_item_id
                recheckBudget = true
                // await checkBudget()
              } else {
                // hasError.value = true
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              alert.error('รายการที่ ' + (i + 1) + e.message)
              // console.log('e: ', e.message)
              // hasError.value = true
            })
        } else {
          await api
            .put(`/preorder/rf/updateItem/${items.value[i].rf_item_id}`, data)
            .then(async res => {
              if (res.code == 200) {
                alert.success()
                recheckBudget = true
                // await checkBudget()
                // items.value[i].rf_item_id = res.data.rf_item_id
              } else {
                // hasError.value = true
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              alert.error('รายการที่ ' + (i + 1) + e.message)
              // console.log('e: ', e.message)
              // hasError.value = true
            })
        }
      }
      if (recheckBudget) {
        await checkBudget()
        await getRFItemSummary()
      }
      // if (hasError.value) {
      //   alert.error('มีบ้างรายการไม่สามารถบันทึกได้')
      //   hasError.value = false
      // }
    }

    watch(
      () => formRF.payeeSelected,
      newVal => {
        if (newVal) {
          // console.log('vendor newVal: ', oldVal, newVal)
          formRF.payeeName = newVal.vendor_name
          formRF.payeeNo = newVal.vendor_code
        }
      }
    )

    const updateItem = async () => {
      validateItem.value.$touch()
      if (!validateItem.value.$invalid) {
        const uom = await store.getters['global/getUOMbyOne'](
          formOFItem.uomSelected
        )
        // items.value[itemIndex.value].pr_item_id = formOFItem.prItemID
        items.value[itemIndex.value].of_item_id = formOFItem.ofItemID
        items.value[itemIndex.value].budget_year = formOFItem.budgetInfo.year
        items.value[itemIndex.value].budget_bu_name =
          formOFItem.budgetInfo.bu_name
        items.value[itemIndex.value].budget_bu_code =
          formOFItem.budgetInfo.bu_code
        items.value[itemIndex.value].budget_subsidiary =
          formOFItem.budgetInfo.subledger !== ''
            ? formOFItem.budgetInfo.subsidiary
            : null
        items.value[itemIndex.value].budget_subledger =
          formOFItem.budgetInfo.subledger !== ''
            ? formOFItem.budgetInfo.subledger
            : null
        items.value[itemIndex.value].budget_subledger_name =
          formOFItem.budgetInfo.subledger !== ''
            ? formOFItem.budgetInfo.subledger_name
            : null

        items.value[itemIndex.value].budget_subledger =
          formOFItem.budgetInfo.subledger
        items.value[itemIndex.value].budget_subsidiary =
          formOFItem.budgetInfo.subsidiary
        items.value[itemIndex.value].budget_code =
          formOFItem.budgetInfo.account_code

        items.value[itemIndex.value].budget_year = formOFItem.bu_year
        items.value[itemIndex.value].budget_name = formOFItem.bu_name

        // items.value[itemIndex.value].uom = formOFItem.uom
        items.value[itemIndex.value].uom = uom.uom_name
        items.value[itemIndex.value].uom_code = uom.uom_code
        items.value[itemIndex.value].use_date = dateFormat(formOFItem.useDate)
        items.value[itemIndex.value].pickup_loc = formOFItem.pickupLoc
        items.value[itemIndex.value].amount = formOFItem.amount
        items.value[itemIndex.value].vat = formOFItem.vat
        items.value[itemIndex.value].qty = formOFItem.qty
        items.value[itemIndex.value].actual_cost = formOFItem.actualCost
        items.value[itemIndex.value].vat_rate = formOFItem.taxVatDefault
        items.value[itemIndex.value].stock_unit_name = formOFItem.stockUnitName
        items.value[itemIndex.value].qty_pos = formOFItem.qtyPos

        items.value[itemIndex.value].item_category =
          formOFItem.materialInfo.material_group
        items.value[itemIndex.value].item_no =
          formOFItem.materialInfo.material_code
        items.value[itemIndex.value].item_name =
          formOFItem.materialInfo.description
        items.value[itemIndex.value].item_code =
          formOFItem.materialInfo.description_code
        items.value[itemIndex.value].item_type =
          formOFItem.materialInfo.material_type
        items.value[itemIndex.value].unit_price = formOFItem.materialInfo.price
        items.value[itemIndex.value].bargain_discount =
          formOFItem.bargainDiscount
        // items.value[itemIndex.value].qty_po_diff = formOFItem.qtyPoDiff
        items.value[itemIndex.value].use_price_type = formOFItem.usePriceType

        items.value[itemIndex.value].wh_tax = formOFItem.whTax
        items.value[itemIndex.value].wh_tax_rate = formOFItem.whTaxDefault

        clearFormItem()

        if (items.value[itemIndex.value].rf_item_id) {
          const data = setDataItem(itemIndex.value)
          await api
            .put(
              `/preorder/rf/updateItem/${
                items.value[itemIndex.value].rf_item_id
              }`,
              data
            )
            .then(async res => {
              if (res.code == 200) {
                // items.value[itemIndex.value].rf_item_id = res.data.rf_item_id
                alert.success()
                await checkBudget()
                await getRFItemSummary()
              } else {
                if (res.validator) {
                  alert.validatorShow(res.validator)
                } else {
                  alert.error(res.message)
                }
              }
            })
            .catch(e => {
              alert.error(e.message)
            })
        } else {
          if (formRF.rfID !== null) {
            const data = setDataItem(itemIndex.value)
            await api
              .post('/preorder/rf/insertItem', data)
              .then(async res => {
                if (res.code == 200) {
                  items.value[itemIndex.value].rf_item_id = res.data.rf_item_id
                  alert.success()
                  await checkBudget()
                  await getRFItemSummary()
                } else {
                  if (res.validator) {
                    alert.validatorShow(res.validator)
                  } else {
                    alert.error(res.message)
                  }
                }
              })
              .catch(e => {
                alert.error(e.message)
              })
          }
        }
      } else {
        alert.error()
      }
    }

    const alertBudget = (isLoading, isOver) => {
      if (isLoading) {
        store.commit('global/setOverBudget', {
          message: 'กำลังตรวจสอบ',
          isOver: true,
          show: true
        })
      } else {
        store.commit('global/setOverBudget', {
          message: isOver == 1 ? 'เกินงบประมาณ' : 'อยู่ในงบประมาณ',
          isOver: isOver == 1,
          show: true
        })
      }
    }

    onUnmounted(() => {
      console.log('unmounted page rf form')
      store.commit('global/setLoadingPage', true)
      store.commit('rf/initBtn')
    })

    const lockField = reactive({
      status: false,
      label: '(ไม่สามารถแก้ไขได้)'
    })

    const getRFItemSummary = async () => {
      // if (route.params.id) {
      await api
        .get(
          `${process.env.VUE_APP_API_URL}/preorder/rf/getByRfId/${formRF.rfID}`
        )
        .then(res => {
          if (res.code == 200) {
            formOF.itemSummary = res.data.itemSummary
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const getRF = async () => {
      if (route.params.id) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/preorder/rf/getByRfId/${route.params.id}`
          )
          .then(res => {
            if (res.code == 200) {
              ofHeaderFormat({
                chosen: res.data.of_array,
                chosenItems: [...res.data.items]
              })

              // formOF.discountAllItem = res.data.po_info.discount_all_item
              // formOF.shipping.date = res.data.po_info.shipping_date
              // formOF.shipping.address = res.data.po_info.shipping_address
              // formOF.shipping.recipient = res.data.po_info.shipping_recipient
              // formOF.shipping.conditionSend =
              //   res.data.po_info.shipping_condition_send
              // formOF.shipping.conditionPayment =
              //   res.data.po_info.payment_term_code
              // formOF.shipping.checkBy = res.data.po_info.shipping_check_by

              // if (res.data.doc_no_full != '') {
              lockField.status = true
              // }
              formRF.payeeSelected = res.data.payee_no
              // isDraft,
              formRF.companySelected = res.data.rf_comp
              formRF.employeeSelected = res.data.req_id
              formRF.telephone = res.data.telephone
              formRF.ofId = res.data.of_id
              formRF.reqDate = res.data.req_date
              formRF.reqDetail = res.data.req_detail
              formRF.invoiceNo = res.data.invoice_no
              formRF.invoiceDate = res.data.invoice_date
              // formRF.instalmentType = res.data.instalment_type
              // formRF.instalmentNo = res.data.instalment_no
              formRF.glDate = res.data.gl_date
              formRF.docNoFull = res.data.doc_no_full

              // formOF.orderTypeText = res.data.order_type_text
              formRF.orderTypeSelected = res.data.order_type

              formRF.approveResultArray = res.data.approve_result_array
              formRF.documentPathArray = res.data.document_path_array
              formRF.nextStatus = res.data.next_status
              formRF.statusCode = res.data.status_code

              formOF.itemSummary = res.data.itemSummary
              specialPathSelected.value = res.data.special_path

              store.commit(
                'rf/setDocumentPathText',
                res.data.document_path_text_array
              )
              store.commit('rf/setDocumentPath', res.data.document_path_array)
              for (const i in res.data.file_attach_array) {
                store.commit('rf/setFile', res.data.file_attach_array[i])
              }

              if (res.data.of_array.length > 0) {
                store.dispatch('global/loadDocumentSpacialPath', {
                  compNo: res.data.of_array[0].of_comp
                })
              }

              if (res.data.ememo_id) {
                formOF.memoSelected = res.data.ememo_id
              }
              if (items.value.length > 0) {
                alertBudget(false, res.data.is_over_budget)
              }

              store.commit('rf/setBtn', { type: 'btnCancel', value: 'hide' })
              if (res.data.status_code != 'RF_DRAFT') {
                store.commit('rf/setBtn', { type: 'btnDraft', value: 'hide' })
              }
              if (
                res.data.is_editing != 1 &&
                res.data.status_code == 'CMD_REVIEW'
              ) {
                store.commit('rf/setBtn', { type: 'btnReject', value: 'hide' })
              }
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
      // await store.commit('global/setLoadingPage', false)
      return true
    }

    const getOFItem = async (poItemID, index) => {
      for (const i in items.value) {
        items.value[i].is_edit = false
      }
      items.value[index].is_edit = true
      boxItemOpen.value = true
      itemIndex.value = index

      // formOFItem.prItemID = items.value[index].pr_item_id
      formOFItem.ofItemID = items.value[index].of_item_id
      formOFItem.budgetInfo = {
        year: items.value[index].budget_year,
        bu_name: items.value[index].budget_bu_name,
        bu_code: items.value[index].budget_bu_code,
        bu_type: items.value[index].budget_subledger
          ? 'งบประมาณโครงการ'
          : 'งบประมาณหน่วยงาน',
        subledger: items.value[index].budget_subledger,
        subsidiary: items.value[index].budget_subsidiary,
        account_code: items.value[index].budget_code,
        account_name: items.value[index].budget_name
      }
      formOFItem.bu_year = items.value[index].budget_year
      formOFItem.bu_name = items.value[index].budget_name
      formOFItem.uom = items.value[index].uom
      formOFItem.uomSelected = items.value[index].uom_code
      formOFItem.useDate = items.value[index].use_date
      formOFItem.pickupLoc = items.value[index].pickup_loc
      formOFItem.amount = items.value[index].amount
        ? numberFormat2(items.value[index].amount)
        : 0
      formOFItem.vat = parseFloat(numberFormat2(items.value[index].vat))
      formOFItem.qty = items.value[index].qty
      formOFItem.actualCost = items.value[index].actual_cost
        ? numberFormat2(items.value[index].actual_cost)
        : 0
      // formOFItem.actualCostTmp = items.value[index].actual_cost
      formOFItem.taxVatDefault = items.value[index].vat_rate
      formOFItem.materialInfo.material_group = items.value[index].item_category
      formOFItem.materialInfo.material_code = items.value[index].item_no
      formOFItem.materialInfo.description = items.value[index].item_name
      formOFItem.materialInfo.description_code = items.value[index].item_code
      formOFItem.materialInfo.material_type = items.value[index].item_type
      formOFItem.materialInfo.price = items.value[index].unit_price
        ? numberFormat2(items.value[index].unit_price)
        : 0
      // formOFItem.taxRate = items.value[index].tax_rate
      // formOFItem.glOffset = items.value[index].gl_offset
      // formOFItem.catCode = items.value[index].cat_code
      formOFItem.bargainDiscount = items.value[index].bargain_discount
      formOFItem.usePriceType = items.value[index].use_price_type
      // formOFItem.qtyPoDiff = items.value[index].qty_po_diff
      formOFItem.whTax = parseFloat(numberFormat2(items.value[index].wh_tax))
      formOFItem.whTaxDefault = items.value[index].wh_tax_rate
      formOFItem.taxWhProcess = items.value[index].wh_tax > 0
      formOFItem.stockUnitName = items.value[index].stock_unit_name
      formOFItem.qtyPos = items.value[index].qty_pos
      // await api
      //   .get(
      //     `${process.env.VUE_APP_API_URL}/preorder/rf/getItemRemain?of_id=${items.value[index].of_id}&of_item_id=${items.value[index].of_item_id}`
      //     // `${process.env.VUE_APP_API_URL}/preorder/rf/getItemRemain?of_id=105&of_item_id=294`
      //   )
      //   .then(res => {
      //     if (res.code == 200) {
      //       remain.sumActualCost = numberFormat(res.data.sum_actual_cost)
      //       remain.instalmentLatest = numberFormat(res.data.instalment_latest)
      //       remain.remainActualCost = numberFormat(res.data.remain_actual_cost)
      //       remain.history = res.data.history
      //     }
      //   })

      return true
    }

    const checkBudget = async () => {
      if (!formRF.rfID || items.value.length == 0) {
        store.commit('global/resetOverBudget')
        if (!formRF.rfID) {
          alert.error('กรุณาบันทึกแบบร่าง')
        } else if (items.value.length == 0) {
          alert.error('กรุณาเพิ่มรายการ RF')
        }
        return
      }
      alertBudget(true, 0)
      await api
        .get(`/preorder/rf/checkOverBudgetByDocId/${formRF.rfID}`)
        .then(res => {
          if (res.code == 200) {
            alertBudget(false, res.data.is_over_budget)
            if (res.data.is_over_budget) {
              alert.error('เกินงบประมาณ')
            }
          }
          return res.data
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const rejectRF = async () => {
      store.commit('rf/setBtnActive', { type: 'btnReject' })
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/preorder/rf/editBeforeApprove/${formRF.rfID}`
        )
        .then(res => {
          if (res.code == 200) {
            store.commit('rf/setBtn', { type: 'btnDraft', value: 'hide' })
            store.commit('rf/setBtn', { type: 'btnSave', value: 'hide' })
            store.commit('rf/setBtn', { type: 'btnReject', value: 'hide' })
            store.commit('rf/setBtnActive', { type: 'btnReject' })
          } else {
            alert.error(res.message)
          }
        })
    }

    // const calUnitPOS = () => {
    //   if (formOFItem.qtyPos != '') {
    //     // 48 - 57 = string
    //     // 0 - 9 = number
    //     // 42 = *
    //     // 43 = +
    //     // 46 = .

    //     let sum = 0
    //     let isPlus = false
    //     let isMulti = false

    //     let num = ''
    //     for (let i = 0; i < formOFItem.qtyPos.toString().length; i++) {
    //       const c = formOFItem.qtyPos.toString().charCodeAt(i)

    //       if ((c >= 0 && c <= 9) || (c >= 48 && c <= 57) || c == 46) {
    //         num += formOFItem.qtyPos.toString().charAt(i)
    //       } else if (c == 42 || c == 43) {
    //         if (isPlus) {
    //           isPlus = false
    //           sum += +num
    //         }
    //         if (isMulti) {
    //           isMulti = false
    //           sum *= +num
    //         }

    //         if (c == 42) {
    //           isMulti = true
    //         }
    //         if (c == 43) {
    //           isPlus = true
    //         }

    //         if (sum == 0) sum = +num
    //         num = ''
    //       }

    //       if (i == formOFItem.qtyPos.toString().length - 1) {
    //         if (isPlus) {
    //           isPlus = false
    //           sum += +num
    //           num = ''
    //         } else if (isMulti) {
    //           isMulti = false
    //           sum *= +num
    //           num = ''
    //         } else {
    //           sum += +num
    //         }
    //       }
    //     }
    //     // console.log('opa: ', formOFItem.qtyPos, '=', sum)
    //     formOFItem.qtyPos = sum
    //   }
    // }

    // const getTaxRate = taxRate => {
    //   return store.getters['global/getTaxRateText'](taxRate)
    // }

    // const getCatCode = catCode => {
    //   return store.getters['global/getCatCodeText'](catCode)
    // }

    // const viewOF = computed(ofId => {
    //   return `/preorder/of/${ofId}/detail`
    // })

    const viewOF = ofId => {
      return `${process.env.VUE_APP_BASE_URL}/preorder/of/form/${ofId}/detail`
    }

    onMounted(async () => {
      console.log('mounted page rf form')
      await store.dispatch('global/loadCompany')
      // store.dispatch('global/loadTaxRate')
      // store.dispatch('global/loadCatCode')
      store.dispatch('global/loadCurrency')
      // store.dispatch('global/loadCash')
      store.dispatch('global/loadFileUploadMaxSize')
      store.commit('global/resetOverBudget')
      // store.dispatch('rf/loadGrOptionInstalmentType')
      // store.dispatch('rf/loadShippingRecipientList')
      // store.dispatch('rf/loadShippingConditionPaymentList')
      // store.dispatch('pr/loadMaterialFilterOption')
      store.dispatch('global/loadUOM')
      await store.dispatch('global/loadDocumentSpacialPath', {
        compNo: store.state.auth.info.comp_no
      })
      await store.dispatch('rf/loadOrderType', {
        compNo: store.state.auth.info.comp_no,
        employeeId: formRF.employeeSelected
      })

      store.commit('rf/setBtnDisplay', { key: 'btnItemSave', status: true })
      store.commit('rf/setBtnDisplay', { key: 'btnSave', status: formRF.rfID })
      store.commit('rf/setBtnDisplay', { key: 'btnDraft', status: true })
      // console.log('mounted: ', companyDefault)
      await getRF()

      // store.dispatch('rf/loadMemo', { ememoId: formOF.memoSelected })
      // store.dispatch('rf/loadOFList', {
      //   employeeId: formRF.employeeSelected,
      //   company: formRF.companySelected
      // })
      // companyChange()
      if (!formRF.rfEdit) {
        await store.dispatch('rf/loadDocumentPath', {
          compNo: companyDefault.value.comp_no,
          employeeId: formRF.employeeSelected
        })
        await onChangeDocumentPath({ target: 'mounted' })
      }
      await store.commit('global/setLoadingPage', false)
    })

    return {
      loadingPage,
      btnSave,
      btnCancel,
      btnDraft,
      btnReject,
      btnItemSave,
      boxItemOpen,
      toggleBoxItemOpen,
      companyDefault,
      companyOptions,
      orderTypeOptions,
      currencyOptions,
      clearFormItem,
      // cashOptions,
      documentSpacialPathOptions,
      specialPathSelected,
      memoOptions,
      fileUploadMaxSize,
      // instalmentOptions,
      formRF,
      formOF,
      formOFItem,
      getOFItem,
      items,
      // companyChange,
      userInfo,
      saveRF,
      saveItem,
      setBudget,
      // setMaterial,
      validateItem,
      setDeleteOFItem,
      confirmDeleteRFItem,
      cancelDeleteRFItem,
      deleteOFItemID,
      checkBudget,
      rejectRF,
      numberFormat,
      dateFormat,
      documentPathText,
      lockField,
      uomOptions,
      // showValidator,
      // isValidator,
      ofChosen,
      docNoFull,
      // shippingRecipientOption,
      // shippingConditionPaymentOption,
      isLoadingRFList,
      updateItem,
      ofList,
      confirmOF,
      modalOFDisplay,
      openModalOFList,
      closedModalOFList,
      // getTaxRate,
      // getCatCode,
      files,
      // instalmentNo,
      validateRF,
      // calActualCost,
      calVat,
      calTax,
      calVatProcess,
      calTaxProcess,
      calPriceQty,
      onChangeDocumentPath,
      summaryAmount,
      employeeDefault,
      // remain,
      vendorInOFOptions,
      selectedMemo,
      // calUnitPOS,
      viewOF
    }
  }
}
</script>

<style scoped>
.vue-select {
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: #e2e8f0;
  border-style: solid;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>
